import Vue from "vue";
import Router from "vue-router";
import VueRouter from "vue-router";

import ViewHolder from "./components/ViewHolder.vue";
import ViewHolderUnkeyed from "./components/ViewHolderUnkeyed.vue";
import profile from "./middleware/profile";


const TrophiesIndex = () =>
    import(/* webpackChunkName: "groups" */ "./views/trophies/Index.vue");
const GroupsIndex = () =>
    import(/* webpackChunkName: "groups" */ "./views/groups/Index.vue");
const GroupsShow = () =>
    import(/* webpackChunkName: "groups" */ "./views/groups/Show.vue");
const GroupsEdit = () => import("./views/groups/Edit.vue");
const EventsIndex = () =>
    import(/* webpackChunkName: "events" */ "./views/events/Index.vue");
const EventsShow = () =>
    import(/* webpackChunkName: "events" */ "./views/events/Show.vue");
const EventsEdit = () => import("./views/events/Edit.vue");
const MessagesIndex = () =>
    import(/* webpackChunkName: "events" */ "./views/messages/Index.vue");
const ProfileIndex = () =>
    import(/* webpackChunkName: "events" */ "./views/profile/Index.vue");
const ProfileEdit = () =>
    import(/* webpackChunkName: "events" */ "./views/profile/Edit.vue");
const CoursesIndex = () =>
    import(/* webpackChunkName: "elearning" */ "./views/courses/Index.vue");
const CoursesShow = () =>
    import(/* webpackChunkName: "elearning" */ "./views/courses/Show.vue");
const LessonShow = () =>
    import(/* webpackChunkName: "elearning" */ "./views/lessons/Show.vue");
const LessonViewHolder = () =>
    import(/* webpackChunkName: "elearning" */ "./views/lessons/LessonViewHolder.vue");
const Room = () => import(/* webpackChunkName: "liveroom" */ "./components/live/Room.vue");

Vue.use(Router);

const routes = [
    {
        path: "/trophies",
        component: ViewHolder,
        children: [
            {
                path: "",
                name: "trophies.index",
                component: TrophiesIndex,
                meta: {
                    disableNav: true,
                }
            },
        ],
    },
    {
        path: "/groups",
        component: ViewHolder,
        children: [
            {
                path: "",
                name: "groups.index",
                component: GroupsIndex,
            },
            {
                path: ":group_slug/edit/:tab?",
                name: "groups.edit",
                component: GroupsEdit,
                meta: {
                    skipCache: true,
                },
            },
            {
                path: ":group_slug/:tab?",
                name: "groups.show",
                component: GroupsShow,
                meta: {
                    skipCache: true,
                },
            },
        ],
    },
    {
        path: "/messages/:id",
        redirect: to => ({
            //"/messages?thread_id=:id"
            name: "messages",
            query: { thread_id: to.params.id },
        }),
    },
    {
        path: "/messages",
        name: 'messages',
        component: MessagesIndex,
        meta: {
            disableNav: true,
            disableChat: true,
            preventScroll: true,
        },
    },
    // No child of /events because we do not want the ViewHolder around the Room component
    {
        path: "/events/:event_slug/live-room",
        name: "liveroom",
        component: Room,
        meta: {
            disableNav: true,
            disableChat: true,
            preventScroll: true,
        },
        props: {
            full_viewport: true,
        }
    },
    {
        path: "/events",
        component: ViewHolder,
        children: [
            {
                path: "",
                name: "events.index",
                component: EventsIndex,
            },
            {
                path: ":event_slug/edit/:tab?",
                name: "events.edit",
                component: EventsEdit,
                meta: {
                    skipCache: true,
                },
            },
            {
                path: ":event_slug/:tab?",
                name: "events.show",
                component: EventsShow,
                meta: {
                    skipCache: true,
                },
            },
        ],
    },

    {
        path: "/profile/settings",
        name: 'profile.edit',
        component: ProfileEdit,
        meta: {
            disableNav: true,
            disableChat: true,
            preventScroll: true,
            middleware: profile,
        },

        children: [
            {
                path: ":type",
                name: 'profile.edit.type',
                component: ProfileEdit,
                meta: {
                    disableNav: true,
                    disableChat: true,
                    preventScroll: true,
                    middleware: profile,
                },

                children: [
                    {
                        path: ":purchase_id",
                        name: 'profile.purchase',
                        component: ProfileEdit,
                        meta: {
                            disableNav: true,
                            disableChat: true,
                            preventScroll: true,
                            middleware: profile,
                        },

                        children: [
                            {
                                path: "invoices",
                                name: 'profile.invoices',
                                component: ProfileEdit,
                                meta: {
                                    disableNav: true,
                                    disableChat: true,
                                    preventScroll: true,
                                    middleware: profile,
                                },
                            },
                            {
                                path: "payment-details",
                                name: 'profile.payment-details',
                                component: ProfileEdit,
                                meta: {
                                    disableNav: true,
                                    disableChat: true,
                                    preventScroll: true,
                                    middleware: profile,
                                },
                            },
                            {
                                path: "cancel-purchase",
                                name: 'profile.cancel-purchase',
                                component: ProfileEdit,
                                meta: {
                                    disableNav: true,
                                    disableChat: true,
                                    preventScroll: true,
                                    middleware: profile,
                                },
                            },
                        ]
                    },
                ]
            },

        ]
    },
    {
        path: "/profile/:username?",
        name: 'profile.index',
        component: ProfileIndex,
        meta: {
            disableNav: true,
            disableChat: true,
            preventScroll: true,
        },
    },
    {
        path: "/resources",
        component: ViewHolderUnkeyed,
        children: [
            {
                path: "",
                name: "courses.index",
                component: CoursesIndex,
                meta: {
                    disableNav: true,
                    transparentBg: true,
                },
            },
            {
                path: ":course_slug",
                name: "courses.show",
                component: CoursesShow,
                meta: {
                    disableNav: true,
                    transparentBg: true,
                },
            },
            {
                path: ":course_slug/:module_slug/:lesson_slug",
                component: LessonViewHolder,
                children: [
                    {
                        path: '',
                        name: "lessons.show",
                        component: LessonShow,
                        meta: {
                            disableNav: true,
                            transparentBg: true,
                            disableChat: true,
                        },
                    }
                ]
            },
        ],
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.matched.some((routeDef) => routeDef.meta.preventScroll))
            return false;
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router;